import React from 'react';
import { Button, Icon } from 'antd';
import utils from '../../../utils';
import fetch from '../../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection = () => {
    return DataGrid.selections;
}

const headers = utils.columns([
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 80
    },
    {
        key: 'schoolName',
        label: '学校名称',
        width: 150
    },
    {
        key: 'surveyName',
        label: '问卷名称',
        width: 150
    },
    {
        key: 'commentContent',
        label: '评语',
        width: 350
    },
    {
        key: 'termName',
        label: '学期',
        width: 150
    }
])

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] !== '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/comment/query?' + params.join('&'), keywords)
        .then((response) => {
            if (response.code === 200) {
                return response.payload.data;
            }
        }).then(data => (
            Object.assign({
                result: data.dataList || [],
                selects: (data.dataList || []).map(d => ({
                    value: d.id,
                    checked: false,
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: (data.dataList || []).length ? '' : '暂无数据...'
            }))
        )
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch
}